import { Chair } from '@mui/icons-material'
import RentEdit from './RentEdit'
import RentCreate from './RentCreate'
import RentList from './RentList'

const rentIndex = {
  icon: Chair,
  list: RentList,
  edit: RentEdit,
  create: RentCreate,
}

export default rentIndex
